export default __webpack_public_path__ + "7a8c8ec6a3917879cb60ad278addf953.png";